module.exports = __webpack_public_path__ + "img/act-now-icon.e190efe5.png";